import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import store from '../store'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);

const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

auth.onAuthStateChanged(user => {
  store.commit('UPDATE_USER', user)
})

const createUser = (email, password, callback) => {
  auth.createUserWithEmailAndPassword(email, password)
  .then(() => {
    return callback({
      success: true,
      exists: false
    })
  })
  .catch(err => {
    if (err.code == 'auth/email-already-in-use') {
      auth.signInWithEmailAndPassword(email, password)
      .then(() => {
        return callback({
          success: true,
          exists: true
        })
      })
      .catch(() => {
        return callback({
          success: false,
          error: 'Incorrect email or password, please try again.'
        })
      })
    } else {
      return callback({
        success: false,
        error: 'Incorrect email or password, please try again.'
      })
    }
  })
}

export {
  db,
  auth,
  currentUser,
  createUser
}
